import ConfirmModal from './ConfirmModal';

export type { IConfirmModalProps } from './ConfirmModal.types';
export default ConfirmModal;
